module.exports = __webpack_public_path__ + "img/002任若凡.c967e781.png";